export default "__VITE_ASSET__CenNg9st__"